module.exports = __webpack_public_path__ + "img/message.2bbaf323.svg";